import classNames from 'classnames';
import { HelpButton } from 'components/1-atoms/HelpButton';
import { RichText } from 'components/1-atoms/RichText';
import { Modal } from 'components/2-molecules/Modal';
import * as React from 'react';
import { useState } from 'react';
import styles from './Table.module.scss';

export interface TableCell {
	text: string;
	align?: boolean;
	helpText?: string;
}

export interface TableData {
	tableHeaders?: string[];
	tableRows?: TableCell[][];
}

export interface TableProps {
	caption?: string;
	compact?: boolean;
	children?: React.ReactElement<HTMLTableSectionElement> | React.ReactElement<HTMLTableSectionElement>[];
	simple?: boolean;
	tableData?: TableData[];
}

export const Table: React.FC<TableProps> = ({ caption, compact = false, children, simple = true, tableData }) => {
	const [openIndex, setOpenIndex] = useState(null);
	return simple ? (
		<div className="table-responsive">
			<table className={classNames('table', 'table-bordered', 'table-hover', { 'table-sm': compact })}>{children}</table>
		</div>
	) : (
		<div className={styles.Table}>
			<table className={styles.Table_asset}>
				{caption && <caption className={styles.Table_caption}>{caption}</caption>}
				{tableData?.map((data, index) => {
					return (
						<React.Fragment key={index}>
							<thead className={classNames(styles.Table_head, data?.tableHeaders?.length === 1 && styles.Table_head___single)}>
								<tr className={styles.Table_row}>
									{data?.tableHeaders?.map((headerName, index) => {
										return (
											<th
												key={index}
												className={styles.Table_cell}
												colSpan={data?.tableHeaders?.length === 1 ? data?.tableRows[0]?.length : null}
												dangerouslySetInnerHTML={{ __html: headerName }}
											/>
										);
									})}
								</tr>
							</thead>
							<tbody>
								{data?.tableRows?.map((row, index) => {
									return (
										<tr key={index} className={styles.Table_row}>
											{row?.map((cell, columnIndex) => {
												return (
													<td key={columnIndex} className={styles.Table_cell}>
														<div
															className={classNames(
																styles.Table_cellContent,
																cell.align && styles.Table_cellContent___right,
															)}
														>
															<span>{cell.text}</span>
															{cell.helpText && (
																<>
																	<HelpButton
																		className={styles.Table_cellHelpBtn}
																		describedById={`row${index}HelpButton`}
																		onClick={() => setOpenIndex(index)}
																		ariaLabel={cell.text}
																	/>
																	<Modal
																		onClose={() => {
																			setOpenIndex(null);
																		}}
																		show={index === openIndex ? true : false}
																	>
																		<RichText content={cell.helpText} />
																	</Modal>
																</>
															)}
														</div>
													</td>
												);
											})}
										</tr>
									);
								})}
							</tbody>
						</React.Fragment>
					);
				})}
			</table>
		</div>
	);
};
